import axios from 'axios';

// Pe net (nu localhost) folosim backend-ul de pe Render dacă REACT_APP_API_URL nu e setat la build
const isProduction = typeof window !== 'undefined' && window.location.hostname !== 'localhost';
const defaultBase = isProduction ? 'https://lead-platform-backend.onrender.com' : 'http://localhost:3001';
export const API_BASE_URL = (process.env.REACT_APP_API_URL || defaultBase).replace(/\/api\/?$/, '');
const API_URL = `${API_BASE_URL}/api`;

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor pentru token JWT
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // FormData: nu seta Content-Type ca axios să poată adăuga boundary (multipart/form-data)
  if (config.data && typeof FormData !== 'undefined' && config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }
  return config;
});

// Interceptor pentru erori
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      console.warn('Authentication error (401/403). Redirecting to login...');
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
